export  enum Roles{
    ADMIN = "Admin",
    CUSTOMER = "customer",
}